import { useDeleteCollectionMutation } from '@sketch/gql-types'
import { removeQuery } from '@sketch/modules-common'
import { useEventDispatch } from '@sketch/utils'
import { removeCollectionFromProject } from './utils/collection.cache'

interface UseDeleteCollectionProps {
  workspaceIdentifier: string
  projectIdentifier: string
  onCompleted?: () => void
}

export const useDeleteCollection = ({
  workspaceIdentifier,
  projectIdentifier,
  onCompleted,
}: UseDeleteCollectionProps) => {
  const dispatchSharesRefresh = useEventDispatch('workspaceShareRefresh')
  const [mutation] = useDeleteCollectionMutation({
    onError: 'show-toast',
    onCompleted,
    update: (cache, { data }) => {
      if (!data) {
        return
      }

      const collectionIdentifier = data.deleteCollection.collection.identifier

      removeCollectionFromProject({
        cache,
        projectIdentifier,
        collectionIdentifier,
      })

      // Invalidate any cached `project.shares` records so that they are
      // refetched from the GraphQL API
      removeQuery(
        cache,
        key => key.includes(projectIdentifier) && key.includes('.shares')
      )
      // Force a refresh of the project view if the user is currently viewing
      // it. Since the user can delete a collection from the project view, we
      // must force a refresh so that the list of shares is refetched after the
      // `removeQuery` call above.
      dispatchSharesRefresh({
        workspaceIdentifier,
        projectShortId: projectIdentifier,
      })
    },
  })

  return mutation
}
